// project imports
import applications from './applications';
import chartsMap from './charts-map';
import formsTables from './forms-tables';
import other from './other';
import pages from './pages';
import restaurant from './restaurant';
import samplePage from './sample-page';
import waiterSearch from './waiter-search';
import widget from './widget';

// types
import { NavItemType } from 'types/menu';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  items: [widget, applications, formsTables, chartsMap, samplePage, pages, other]
};

export default menuItems;

export const restaurantItems: { items: NavItemType[] } = {
  items: [restaurant, waiterSearch]
};
